import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { CartProvider } from "./context/CartContext";
import { HomePage } from "./pages/HomePage";
import { ProductPage } from "./pages/ProductPage";
import { ContactPage } from "./pages/ContactPage";
import { CollectionPage } from "./pages/CollectionPage";
import { CartPage } from "./pages/CartPage";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentPages";
// import { EmailCaptureModal } from "./components/EmailCaptureModal"; // Disabled during pre-launch — reactivate after store opens.
import { LaunchNotifyModal } from "./components/LaunchNotifyModal";
import { AnalyticsBootstrap } from "./components/AnalyticsBootstrap";
import { RouteAnalytics } from "./components/RouteAnalytics";
import { ConsentBanner } from "./components/ConsentBanner";

function App() {
  return (
    <LanguageProvider>
      <CartProvider>
        <BrowserRouter>
          <AnalyticsBootstrap />
          <RouteAnalytics />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/collection" element={<CollectionPage />} />
            <Route path="/product/:slug" element={<ProductPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
          <LaunchNotifyModal />
          <ConsentBanner />
        </BrowserRouter>
      </CartProvider>
    </LanguageProvider>
  );
}

export default App;
